import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './store/store'
import { redirectToLogin } from './utils/sessionExpired'

import 'firebase/auth' // เพิ่มหากต้องการใช้ auth
import 'firebase/firestore' // เพิ่มหากใช้ firestore
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/css/main.css'
import '@/assets/css/design-system.css'
import '@/assets/css/mobile.css'
import '@/assets/scss/editorstyles.scss'
import '@/assets/scss/adstyle.scss'
import '@/assets/scss/aiadstyle.scss'
import '@/assets/scss/modal.scss'

// import VueConfirmDialog from 'vue3-confirm-dialog'
import axios from './axios.js'
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
import { auth, db } from './firebase'
import { VueSpinnersPlugin } from 'vue3-spinners';
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import Vue3ConfirmDialog from 'vue3-confirm-dialog';
import 'vue3-confirm-dialog/style';

import Notifications from '@kyvg/vue3-notification'

import Swal from 'sweetalert2'
import AddonsPlugin from "./plugins/addons.js";

if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
}

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.warn('⚠️ Unauthorized - redirect to login page')
      redirectToLogin()
    }
    return Promise.reject(error)
  }
)
// ✅ สร้าง Vue app
const app = createApp(App)

app.use(ContextMenu)
app.use(VueSpinnersPlugin);
app.use(VueSidebarMenu)

app.use(Vue3ConfirmDialog);
app.component('vue3-confirm-dialog', Vue3ConfirmDialog.default)
app.use(Notifications)
app.config.globalProperties.$swal = Swal  // 👈 เพิ่มตรงนี้
console.count('login')


// ✅ Global Properties (เหมือน Vue.prototype)
app.config.globalProperties.$http = axios
app.config.globalProperties.$storex = store
app.config.globalProperties.$auth = auth
app.config.globalProperties.$db = db

app.use(AddonsPlugin);

// ✅ ใช้ Plugin ต่างๆ
app.use(router)
app.use(store)  // ติดตั้ง Vuex store

app.use(createPinia())
app.mount('#app')

// app.use(VueConfirmDialog)

// // ✅ Component Global
// app.component('vue-confirm-dialog', VueConfirmDialog.default)

